import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl,
} from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { EventService } from "src/app/core/services/event.service";
import { ApiService } from "src/app/shared/services/api.service";
import Swal from "sweetalert2";
import { saveAs } from "file-saver";
import { MatDatepicker } from "@angular/material/datepicker";
import {
  statusPaymentMap,
  statusPaymentColorMap,
} from "../../shared/constants";
import { PDFDocument } from "pdf-lib";

@Component({
  selector: "app-account-registration-management",
  templateUrl: "./account-registration-management.component.html",
  styleUrls: ["./account-registration-management.component.scss"],
})
export class AccountRegistrationManagementComponent implements OnInit {
  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private modalService: NgbModal,
    public formBuilder: FormBuilder,
    private eventService: EventService,
    private translateService: TranslateService,
    private router: Router,
    private fb: FormBuilder,
  ) {}

  statusPaymentMap = statusPaymentMap;
  statusPaymentColorMap = statusPaymentColorMap;
  listData = [];
  pageSize = 10;
  pageIndex = 1;
  params = "";
  searching;
  totalCount = 0;
  tableName = "admin/customer-orders";
  role = JSON.parse(localStorage.getItem("currentUser"))["role"];
  full_name = JSON.parse(localStorage.getItem("currentUser")).full_name;
  submitted: boolean;
  formData: FormGroup;
  listModel = ["MD712", "MD716", "MD760", "Y50", "Y56", "F91"];
  listVersion = ["Paybox", "Soundbox"];
  listStatus = [
    { value: "cancel", label: "Huỷ" },
    { value: "pending_payment", label: "Chờ thanh toán" },
    { value: "processing", label: "Đang đợi xử lý" },
    { value: "complete", label: "Đã liên kết loa" },
    { value: "ready_to_pick", label: "Sẵn sàng để lấy hàng" },
    { value: "picking", label: "Đang lấy hàng" },
    { value: "delivering", label: "Đang giao hàng" },
    { value: "transporting", label: "Đang vận chuyển" },
    { value: "money_collect_picking", label: "Thu tiền khi lấy hàng" },
    { value: "picked", label: "Đã lấy hàng" },
    { value: "storing", label: "Đang phân loại" },
    { value: "money_collect_delivering", label: "Thu tiền khi giao hàng" },
    { value: "delivered", label: "Đã giao hàng" },
    { value: "delivery_fail", label: "Giao hàng thất bại" },
    { value: "return_fail", label: "Trả hàng thất bại" },
    { value: "exception", label: "Ngoại lệ" },
    { value: "damage", label: "Hư hỏng" },
    { value: "lost", label: "Mất" },
    { value: "return", label: "Trả hàng" },
    { value: "waiting_to_return", label: "Đang chờ trả hàng" },
    { value: "return_transporting", label: "Đang vận chuyển trả hàng" },
    { value: "return_sorting", label: "Đang phân loại trả hàng" },
    { value: "refunded", label: "Đã hoàn tiền" },
    { value: "returning", label: "Đang trả hàng" },
    { value: "returned", label: "Đã trả hàng" },
    { value: "confirmed", label: "Đã xác nhận" },
  ];
  breadCrumbItems;
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  listDevices;
  get form() {
    return this.formData.controls;
  }
  filter = {
    type_id: "",
    phone: "",
    month: "",
    year: "",
    email: "",
    recipientPhone: "",
    status: "",
    deliveryMethod: "",
    startDay: null,
    endDay: null,
    referrer: "",
    terminal_bank_acc: "",
    serial_number: "",
  };

  ngOnInit() {
    this.breadCrumbItems = [
      { label: "PAGE.HOME" },
      { label: "PAGE.REPORT.IncidentType", active: true },
    ];
    this.formData = this.fb.group({
    refund_amount: [null],
    refund_date: [null],
    refund_ft_code: [null]
  });
    this.fetchData();
    this.filterStatusListByRole();
    this.range.valueChanges.subscribe((rangeValues) => {
      const formatDate = (date: Date | null) => {
        if (!date) return null;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };
      this.filter.startDay = formatDate(rangeValues.start);
      this.filter.endDay = formatDate(rangeValues.end);
    });
    this.date.valueChanges.subscribe((selectedMonth) => {
      if (selectedMonth && selectedMonth.selectedMonth) {
        const year = selectedMonth.selectedMonth.getFullYear();
        const month = String(
          selectedMonth.selectedMonth.getMonth() + 1
        ).padStart(2, "0");
        this.filter.month = month;
        this.filter.year = year;
      }
    });
  }

  date = new FormGroup({
    selectedMonth: new FormControl(null),
  });

  selectedMonth: { month: string; year: string } | null = null;
  filterStatusListByRole(): void {
    const allowed = this.statusByRole[this.role];
    this.filteredStatusList = this.statusList?.filter((s) =>
      allowed?.includes(s.value)
    );
  }
  onMonthSelected(event: Date, datepicker: MatDatepicker<Date>) {
    const year = event.getFullYear();
    const month = event.getMonth();
    this.date.controls["selectedMonth"].setValue(new Date(year, month, 1));
    console.log("📅 Tháng được chọn:", { month: month + 1, year });
    datepicker.close();
  }

  handleOrder(data) {
    Swal.fire({
      title: this.translateService.instant("FORM.Warning"),
      text: this.translateService.instant(
        "Bạn có chắc chắn muốn tạo đơn hàng?"
      ),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#ff3d60",
      confirmButtonText: this.translateService.instant("FORM.WarningConfirm"),
      cancelButtonText: this.translateService.instant("FORM.Cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        this.apiService
          .postItem(`admin/customer-orders/` + data.id, {})
          .subscribe({
            next: () => {
              this.apiService.showToastMobile(
                this.translateService.instant("success"),
                this.translateService.instant("Tạo đơn hàng thành công")
              );
              this.fetchData();
            },
            error: (err) => {
              if (err === "Internal Server Error") {
                this.apiService.showToastMobile(
                  "error",
                  this.translateService.instant("Lỗi máy chủ")
                );
              } else {
                this.apiService.showToastMobile("error", err);
              }
            },
          });
      }
    });
  }

  onLink(data, contentLink) {
    this.getCountDevice(data.id);
    this.formData = this.makeForm(data);
    this.modalService.open(contentLink, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }

  clearFilter() {
    this.params = "";
    this.filter.serial_number = "";
    this.filter.type_id = "";
    this.filter.status = "";
    this.filter.referrer = "";
    this.filter.recipientPhone = "";
    this.filter.phone = "";
    this.filter.email = "";
    this.filter.terminal_bank_acc = "";
    this.filter.deliveryMethod = "";
    this.filter.startDay = null;
    this.filter.endDay = null;
    this.range.reset();
    this.pageIndex = 1;
    this.searching = false;
    this.fetchData();
  }

  submitFilter() {
    this.params = "";
    this.pageIndex = 1;
    this.searching = true;

    for (const key in this.filter) {
      const value = this.filter[key];
      if (value !== null && value !== undefined && value !== "") {
        this.params += `&${key}=${encodeURIComponent(value)}`;
      }
    }

    this.fetchData();
  }

  onCheckPayment(data) {
    this.apiService.checkOrderPayment(data).subscribe({
      next: (res: any) => {
        const status = res?.status || res?.metadata?.status;
        this.checkedOrderStatus = status;
        this.checkedOrderData = res.order || res.data || data;
        this.showOrderStatusPopup = true;
      },
      error: (err) => {
        this.showOrderStatusPopup = false;
        this.apiService.showToast(
          this.translateService.instant("FORM.Error"),
          err?.error?.message ||
            this.translateService.instant(
              "Không kiểm tra được trạng thái thanh toán"
            ),
          "error"
        );
      },
    });
  }

  confirmCheckPayment() {
    this.apiService.checkOrderPayment(this.checkedOrderData).subscribe({
      next: (res: any) => {
        const status = res?.status || res?.metadata?.status;
        this.checkedOrderStatus = status;
        this.checkedOrderData = res.order || res.data || this.checkedOrderData;
        this.showOrderStatusPopup = true;
        this.fetchData();
      },
      error: (err) => {
        this.showOrderStatusPopup = false;
        this.apiService.showToast(
          this.translateService.instant("FORM.Error"),
          err?.error?.message ||
            this.translateService.instant(
              "Không kiểm tra được trạng thái thanh toán"
            ),
          "error"
        );
      },
    });
  }

  closeOrderStatusPopup() {
    this.showOrderStatusPopup = false;
    this.fetchData();
  }

  orderId;
  fetchData() {
    this.eventService.setLoading(true);
    const endpoint = "invoice-service-orders/pending";
    // const endpoint = "invoice-service-orders/list?status=PAID";
    const Url = `${endpoint}?page=${this.pageIndex}&limit=${this.pageSize}${this.params}`;
    this.apiService.getList(Url).subscribe({
      next: (res: any) => {
        this.listData = res.metadata?.results || [];
        this.totalCount = res.metadata.pagination.totalCount;
        this.eventService.setLoading(false);
      },
      error: (err) => {
        this.apiService.showToastMobile(
          "error",
          err || "Có lỗi xảy ra khi tải dữ liệu."
        );
        this.eventService.setLoading(false);
      },
    });
  }

  countDevice;
  getCountDevice(id) {
    this.apiService
      .getList("cs/device-subscription?customerOrderId=" + id)
      .subscribe({
        next: (res) => {
          this.formData.patchValue({
            quantity: res.metadata.missingDevices,
          });
        },
      });
  }

  isAllSelected: boolean = false;

  checkIfAllSelected(): void {
    this.isAllSelected = this.listData
      .filter((item) => item.order_info?.status !== "REGISTERED")
      .every((item) => item.selected);
  }

  toggleAllSelections(): void {
    this.listData.forEach((item) => {
      item.selected = this.isAllSelected;
    });
  }

  // ...

  checkSelectedOrders(): void {
    const selectedOrderIds = this.listData
      .filter((order) => order.selected)
      .map((order) => order.id);

    if (selectedOrderIds.length === 0) {
      this.apiService.showToast(
        this.translateService.instant("FORM.Warning"),
        this.translateService.instant("Vui lòng chọn ít nhất một đơn hàng"),
        "warning"
      );
      return;
    }

    const payload = { orderIds: selectedOrderIds };

    this.eventService.setLoading(true);

    this.http
      .post("acc-viettel-invoice/template-import-accounts", payload, {
        responseType: "blob",
      })
      .subscribe({
        next: (res: Blob) => {
          this.eventService.setLoading(false);
          saveAs(res, "Danh_sach_KH_dang_ky.xlsx");
        },
        error: (err) => {
          this.eventService.setLoading(false);

          // Nếu là lỗi dạng Blob chứa JSON, dùng FileReader để đọc
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errorText = reader.result as string;
              const errorJson = JSON.parse(errorText);
              const message =
                errorJson.message ||
                this.translateService.instant("Tải xuống danh sách thất bại");

              this.apiService.showToastMobile("error", message);
            } catch (e) {
              // Nếu không đọc được JSON, hiển thị lỗi mặc định
              this.apiService.showToastMobile(
                "error",
                this.translateService.instant("Tải xuống danh sách thất bại")
              );
            }
          };

          if (err.error instanceof Blob) {
            reader.readAsText(err.error);
          } else {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant("Tải xuống danh sách thất bại")
            );
          }
        },
      });
  }

  onDownload(data: any): void {
    this.eventService.setLoading(true);

    this.apiService
      .getList(`invoice-service-orders/files/${data.id}`)
      .subscribe({
        next: async (response: any) => {
          this.downloadImagesAsPdf(response?.metadata?.files);
          this.eventService.setLoading(false);
        },
        error: (err) => {
          console.error("Lỗi khi tải file PDF:", err);
        },
      });
  }

  async downloadImagesAsPdf(files: any): Promise<void> {
    const pdfDoc = await PDFDocument.create();

    const imageKeys = [
      "citizen_front_image",
      "citizen_backend_image",
      "business_license_image",
      "tax_certificate_image",
      "signature_image",
    ];

    for (const key of imageKeys) {
      const file = files[key];
      if (!file?.base64 || !file?.mimeType) continue;
    
      try {
        const imageBytes = this.base64ToUint8Array(file.base64);
        let embeddedImage;
    
        if (file.mimeType === "image/png") {
          embeddedImage = await pdfDoc.embedPng(imageBytes);
        } else if (
          file.mimeType === "image/jpeg" ||
          file.mimeType === "image/jpg"
        ) {
          embeddedImage = await pdfDoc.embedJpg(imageBytes);
        } else {
          console.warn(`Unsupported image type for ${key}`);
          continue;
        }
    
        const imgWidth = embeddedImage.width;
        const imgHeight = embeddedImage.height;
    
        const page = pdfDoc.addPage([imgWidth, imgHeight]);
        page.drawImage(embeddedImage, {
          x: 0,
          y: 0,
          width: imgWidth,
          height: imgHeight,
        });
      } catch (err) {
        console.error(`❌ Lỗi nhúng ảnh ${key}:`, err, file);
      }
    }
    

    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    saveAs(blob, "register_files.pdf");
  }

  base64ToUint8Array(base64: string): Uint8Array {
    const binary = atob(base64);
    const len = binary.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
  }

  onUpdate(data: any) {
    // logic kiểm tra trạng thái thanh toán
  }

  onEdit(data, content) {
    console.log(data);

    this.orderId = data.id;
    this.formData = this.makeForm(data);
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }

  selectedIncident = null;
  selectedKeyword = null;
  exportExel() {
    this.submitFilter();
    this.eventService.setLoading(true);

    const headers = new HttpHeaders({
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = "reports/export-orders?" + this.params;

    this.http.get(url, { headers, responseType: "blob" }).subscribe({
      next: (res: Blob) => {
        this.eventService.setLoading(false);
        saveAs(res, "Bao_cao.xlsx");
      },
      error: (e) => {
        if (e) {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e)
          );
        } else {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Xuất file lỗi")
          );
        }
        this.eventService.setLoading(false);
      },
    });
  }

  exportExelBranch() {
    this.eventService.setLoading(true);
    const headers = new HttpHeaders({
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = "dashboard/device-branch?model=export";

    this.http.get(url, { headers, responseType: "blob" }).subscribe({
      next: (res: Blob) => {
        this.eventService.setLoading(false);
        saveAs(res, "Bao_cao_chi_nhanh.xlsx");
      },
      error: (e) => {
        if (e) {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e)
          );
        } else {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Xuất file lỗi")
          );
        }
        this.eventService.setLoading(false);
      },
    });
  }

  downloadTemplate(): void {
    this.eventService.setLoading(true);
    const url = "acc-viettel-invoice/download-template";
    const headers = new HttpHeaders({
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    this.http.get(url, { headers, responseType: "blob" }).subscribe({
      next: (blob: Blob) => {
        saveAs(blob, "Mau_nhap_lieu_hoa_don.xlsx");
        this.eventService.setLoading(false);
      },
      error: (err) => {
        this.apiService.showToastMobile(
          "error",
          this.translateService.instant("Tải file mẫu thất bại!")
        );
        this.eventService.setLoading(false);
      },
    });
  }

  statusList = [
    { value: "RECEIVED", label: "Đã tiếp nhận" },
    { value: "MISSING_RECORDS", label: "Thiếu hồ sơ" },
    { value: "ACCOUNT_ISSUED", label: "Đã cấp tài khoản" },
    { value: "REGISTRATION_CANCELLED", label: "Hủy đăng ký" },
    { value: "REFUNDED", label: "Đã hoàn tiền" },
  ];
  statusByRole = {
    viettel_invoice: ["RECEIVED", "MISSING_RECORDS"],
    admin: [
      "RECEIVED",
      "MISSING_RECORDS",
      "REGISTRATION_CANCELLED",
      "REFUNDED",
    ],
    "customer service": ["REGISTRATION_CANCELLED", "REFUNDED"],
  };

  selectedStatus: string | null = null;
  filteredStatusList: any[] = [];
  updateStatus() {
    const selectedIds = this.listData
      .filter((item) => item.selected)
      .map((item) => item.id);

    if (!this.selectedStatus) {
      this.apiService.showToast(
        this.translateService.instant("FORM.Warning"),
        this.translateService.instant("Vui lòng chọn trạng thái cần cập nhật"),
        "warning"
      );
      return;
    }

    if (selectedIds.length === 0) {
      this.apiService.showToast(
        this.translateService.instant("FORM.Warning"),
        this.translateService.instant("Vui lòng chọn ít nhất một đơn hàng"),
        "warning"
      );
      return;
    }

    const payload: any = {
      ids: selectedIds,
      status: this.selectedStatus,
    };

    if (this.selectedStatus === 'REFUNDED') {
      const { refund_amount, refund_date, refund_ft_code } = this.formData.value;
      if (!refund_amount || !refund_date || !refund_ft_code) {
        this.apiService.showToast("Lỗi", "Vui lòng nhập đầy đủ thông tin hoàn tiền", "error");
        return;
      }
      payload.refund_amount = +refund_amount;
      payload.refund_date = refund_date;
      payload.refund_ft_code = refund_ft_code;
    }
    this.eventService.setLoading(true);
    this.http.put("invoice-service-orders/update", payload).subscribe({
      next: (res) => {
        this.apiService.showToast(
          this.translateService.instant("FORM.Success"),
          this.translateService.instant("Cập nhật trạng thái thành công"),
          "success"
        );
        this.selectedStatus = null;
        this.formData.reset();
        this.fetchData();
        this.modalService.dismissAll();
        this.eventService.setLoading(false);
      },
      error: (err) => {
        this.apiService.showToast(
          this.translateService.instant("FORM.Error"),
          err || this.translateService.instant("Cập nhật trạng thái thất bại"),
          "error"
        );
      },
      complete: () => {
        this.eventService.setLoading(false);
      },
    });
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (file) {
      this.uploadImportFile(file);
    }
    event.target.value = null;
  }
  errorImportList: any[] = [];
  isShowErrorModal = false;
  errorSummary = "";

  uploadImportFile(file: File): void {
    this.eventService.setLoading(true);
    const formData = new FormData();
    formData.append("file", file, file.name);

    const url = "acc-viettel-invoice/import-excel";

    this.http.post<{ message: string }>(url, formData).subscribe({
      next: (res) => {
        const meta = (res as any)?.metadata;
        const total = meta?.total ?? 0;
        const success = meta?.success ?? 0;
        const failed = meta?.failed ?? 0;

        if (success === total && total > 0) {
          this.apiService.showToast(
            this.translateService.instant("FORM.Success"),
            `Import thành công ${success}/${total} tài khoản.`,
            "success"
          );
        } else {
          // Gán dữ liệu lỗi để hiển thị popup
          this.errorImportList = meta?.errors || [];
          this.errorSummary = `Import ${success}/${total} tài khoản thành công.`;
          this.isShowErrorModal = true;
        }

        this.fetchData();
      },
      error: (err) => {
        this.apiService.showToast(
          this.translateService.instant("FORM.Error"),
          err?.error?.message ||
            this.translateService.instant("Import dữ liệu thất bại!"),
          "error"
        );
      },
      complete: () => {
        this.eventService.setLoading(false);
      },
    });
  }

  makeFormKeyword(d) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      id: [data.id],
      name: [data.name],
      incident_type_id: [data.incident_type_id],
    });
  }

  fetchKeyword() {
    this.dataKeyword = [];
    this.eventService.setLoading(true);
    this.apiService
      .getList(`keyword?type_id=${this.selectedIncident.id}`)
      .subscribe({
        next: (res) => {
          console.log(res);
          this.dataKeyword = [...res];
          this.eventService.setLoading(false);
        },
      });
  }

  dataKeyword = [];

  formEditKeyword: FormGroup;
  formNewKeyword: FormGroup;
  editKeyword(data, index) {
    this.formEditKeyword = this.makeFormKeyword(data);
    this.selectedKeyword = data;
  }

  onSubmitFormKeyword(type) {
    if (type == 1) {
      if (this.formEditKeyword.valid) {
        const value = this.formEditKeyword.value;
        this.eventService.setLoading(true);
        this.apiService.editItem("keyword", value.id, value).subscribe({
          next: (res) => {
            this.selectedKeyword = null;
            this.fetchKeyword();
            this.eventService.setLoading(false);
          },
        });
      }
    } else {
      if (this.formNewKeyword.valid) {
        const value = this.formNewKeyword.value;
        this.eventService.setLoading(true);
        this.apiService.addItem("keyword", value).subscribe({
          next: (res) => {
            this.eventService.setLoading(false);
            this.formNewKeyword.reset({
              incident_type_id: this.selectedIncident.id,
            });
            this.fetchKeyword();
          },
        });
      }
    }
  }

  onOpenKeywordModal(content, incident) {
    this.selectedIncident = incident;
    this.fetchKeyword();
    this.formNewKeyword = this.makeFormKeyword({
      incident_type_id: this.selectedIncident.id,
    });
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }

  onDeleteKeyword(id) {
    if (id) {
      this.eventService.setLoading(true);
      this.apiService.deleteItem("keyword", id).subscribe((res) => {
        Swal.fire(
          this.translateService.instant("FORM.Success"),
          this.translateService.instant("FORM.SuccessMessageDelete"),
          "success"
        ).then((res) => {
          this.fetchKeyword();
        });
        this.eventService.setLoading(false);
      });
    }
  }

  onDelete(data) {
    Swal.fire({
      title: this.translateService.instant("FORM.Warning"),
      text: this.translateService.instant("FORM.WarningMessage"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#ff3d60",
      confirmButtonText: this.translateService.instant("FORM.WarningConfirm"),
      cancelButtonText: this.translateService.instant("FORM.Cancel"),
    }).then((result) => {
      if (result.value) {
        this.apiService.deleteItem(this.tableName, data).subscribe((res) =>
          Swal.fire(
            this.translateService.instant("FORM.Success"),
            this.translateService.instant("FORM.SuccessMessageDelete"),
            "success"
          ).then((res) => {
            this.fetchData();
          })
        );
      }
    });
  }

  viewDetails(data: any) {
    this.router.navigate(["/orders-manager/detail-orders/", data.id]);
  }

  makeForm(d?) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      accountName: ["", Validators.required],
      accountPassword: ["", Validators.required],
      taxCode: ["", Validators.required],
      invoice_type: ["", Validators.required],
      template_code: ["", Validators.required],
      invoice_series: ["", Validators.required],
      business_type: ["household", Validators.required],
      refund_amount: [data.refund_amount || null, [Validators.pattern("^[0-9]*$")]],
      refund_date: [data.refund_date || null],
      refund_ft_code: [data.refund_ft_code || null, [Validators.pattern("^[a-zA-Z0-9]*$")]],
    });
  }

  onInputFormat(controlName: string, type: 'number' | 'alphanumeric') {
  const control = this.formData.get(controlName);
    if (control && control.value) {
      const regex = type === 'number' ? /[^0-9]/g : /[^a-zA-Z0-9]/g;
      const cleanValue = control.value.replace(regex, '');
      control.setValue(cleanValue, { emitEvent: false });
    }
  }
  
  onUpdateCustomer() {
    const value = this.formData.value;
    const payload = {
      accountName: value.accountName,
      accountPassword: value.accountPassword,
      taxCode: value.taxCode,
      invoice_type: value.invoice_type,
      template_code: value.template_code,
      invoice_series: value.invoice_series,
      business_type: value.business_type,
      orderId: this.orderId,
    };
    this.apiService
      .postItem("acc-viettel-invoice/link-account-for-partner", payload)
      .subscribe({
        next: (res) => {
          this.apiService.showToast(
            this.translateService.instant("FORM.Success"),
            this.translateService.instant("Cập nhật tài khoản thành công"),
            "success"
          );
          this.fetchData();
        },
        error: (err) => {
          this.apiService.showToast(
            this.translateService.instant("FORM.Error"),
            this.translateService.instant(err || "Cập nhất tài khoản thất bại"),
            "error"
          );
        },
      });
  }
  saveData() {
    this.submitted = true;
    if (this.formData.valid) {
      const value = this.formData.value;
      value["status"] = value["status"] == true ? 1 : 0;
      this.eventService.setLoading(true);
      if (value.id) {
        this.apiService.editItem(this.tableName, value.id, value).subscribe({
          next: (res) => {
            this.submitted = false;
            this.formData.reset();
            this.fetchData();
            this.modalService.dismissAll();
            this.apiService.showToast(
              this.translateService.instant("FORM.Success"),
              this.translateService.instant("FORM.SuccessMessage"),
              "success"
            );
            this.eventService.setLoading(false);
          },
          error: (e) => {
            this.apiService.showToast(
              this.translateService.instant("FORM.Error"),
              this.translateService.instant("FORM.ErrorMessage"),
              "error"
            );
            this.eventService.setLoading(false);
          },
        });
      } else {
        this.apiService.addItem(this.tableName, value).subscribe({
          next: (res) => {
            this.fetchData();
            this.apiService.showToast(
              this.translateService.instant("FORM.Success"),
              this.translateService.instant("FORM.SuccessMessageAdd"),
              "success"
            );
            this.eventService.setLoading(false);
            this.modalService.dismissAll();
          },
          error: (e) => {
            this.apiService.showToast(
              this.translateService.instant("FORM.Error"),
              this.translateService.instant("FORM.ErrorMessageAdd"),
              "error"
            );
            this.eventService.setLoading(false);
          },
        });
      }
    } else {
      console.log("invalid", this.formData);
      Object.values(this.formData.controls).forEach((control) => {
        if (control.status == "INVALID") {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  selectedOrder: any = null;
  public showOrderStatusPopup: boolean = false;
  public checkedOrderStatus: string = "";
  public checkedOrderData: any = null;
}
